export default "__VITE_ASSET__DxCeTCmj__"